import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AuthContext } from 'contexts/AuthContext';
import { getLandingPathForUser, requiresClinicSetup } from 'utils/accessControl';

const GuestGuard = ({ children }) => {
  const { isLoggedIn, user } = useContext(AuthContext);
  const location = useLocation();

  const currentPath = location.pathname || window.location.pathname || '';
  const currentSearch = location.search || window.location.search || '';
  const isSetupRoute = 
    currentPath.startsWith('/setup') ||
    currentPath.startsWith('/s/') ||
    currentPath.startsWith('/clinic-admin/setup') ||
    currentPath.startsWith('/clinic/setup') ||
    currentPath.startsWith('/clinic-admin/register') ||
    currentSearch.includes('token=') ||
    currentSearch.includes('clinic_id=') ||
    currentSearch.includes('t=');

  if (isSetupRoute) {
    return children;
  }

  // If user already logged in redirect to dashboard (unless on clinic setup page)
  if (isLoggedIn) {
    return (
      <Navigate
        to={requiresClinicSetup(user) ? '/clinic-admin/setup' : getLandingPathForUser(user)}
        replace
      />
    );
  }

  // Otherwise allow access

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
